import { render, staticRenderFns } from "./FCreditor.vue?vue&type=template&id=6403611d&"
import script from "./FCreditor.vue?vue&type=script&lang=ts&"
export * from "./FCreditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports